import styled from 'styled-components'
import { FunctionComponent } from 'react'
import { ItemSuperUserIndicatorProps } from './types'

const SuperUserBorder = styled.div`
  background-color: ${({ theme }) => theme.colors.brandColors.brand_55};
  height: 100%;
  width: 5px;
  position: absolute;
  top: 0;
  left: 0;
`

const SuperUserFlag = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 2px 16px 1px 8px;

  background-color: ${({ theme }) => theme.colors.brandColors.brand_55};
  color: ${({ theme }) => theme.colors.white};

  font-size: 12px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.goodOT};
  text-transform: uppercase;

  &:after {
    content: ' ';
    position: absolute;
    right: 0;
    top: 0;
    border-right: 12px solid ${({ theme }) => theme.colors.grey.grey_20};
    border-bottom: 10.5px solid transparent;
    border-top: 10.5px solid transparent;
  }
`

const ItemSuperUserIndicator: FunctionComponent<
  ItemSuperUserIndicatorProps
> = ({ authorType }) => (
  <>
    <SuperUserBorder />
    <SuperUserFlag>{authorType}</SuperUserFlag>
  </>
)

export default ItemSuperUserIndicator
